import { __generator } from "tslib";
import { eventChannel, buffers } from 'redux-saga';
import { all, takeEvery, put, select, take, fork, delay, } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { receiveHubMessage } from './actions';
import { fetchFeedbackCount } from '../../publicSession/actions';
import { addNotificationToQueue } from '../../Notifications/redux/actionCreators';
import { NotificationType } from '../../Notifications/redux/types';
import { HubChannel } from './types';
import { appMounted } from '../app/actions';
import { getHubState } from '../../publicSession/selectors';
import { dreamupGenerationSucceeded, dreamupGenerationFailed, } from '../dreamup/actions';
export function handleHubMessage(_a) {
    var channel, data, _b, notificationData, dreamupData;
    var payload = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                channel = payload.channel, data = payload.data;
                _b = channel;
                switch (_b) {
                    case HubChannel.NOTIFICATIONS: return [3 /*break*/, 1];
                    case HubChannel.NEW_FEEDBACK: return [3 /*break*/, 3];
                    case HubChannel.DREAMSOFART: return [3 /*break*/, 5];
                }
                return [3 /*break*/, 10];
            case 1:
                notificationData = data.data;
                return [4 /*yield*/, put(addNotificationToQueue('live', NotificationType.Live, notificationData))];
            case 2:
                _c.sent();
                ddt.log('hub', 'live notification enqueued', notificationData);
                return [3 /*break*/, 11];
            case 3: return [4 /*yield*/, put(fetchFeedbackCount())];
            case 4:
                _c.sent();
                ddt.log('hub', 'new feedback received');
                return [3 /*break*/, 11];
            case 5:
                dreamupData = data.data;
                if (!(dreamupData.status === 'complete')) return [3 /*break*/, 7];
                return [4 /*yield*/, put(dreamupGenerationSucceeded(dreamupData.generation_id, dreamupData.deviationids))];
            case 6:
                _c.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, put(dreamupGenerationFailed(dreamupData.generation_id))];
            case 8:
                _c.sent();
                _c.label = 9;
            case 9:
                ddt.log('hub', 'dreamup art generation finished', dreamupData);
                return [3 /*break*/, 11];
            case 10: return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function handleAppMounted() {
    var hub, hubUtils, e_1, hubChannel, message, _a, channel, data, channelName;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: 
            // wait for mount before doing anything
            return [4 /*yield*/, take(appMounted)];
            case 1:
                // wait for mount before doing anything
                _b.sent();
                return [4 /*yield*/, select(getHubState)];
            case 2:
                hub = _b.sent();
                if (!hub) {
                    return [2 /*return*/];
                }
                // disable hub inside iframes
                if (typeof window !== 'undefined' && window.top !== window.self) {
                    return [2 /*return*/];
                }
                // uncomment this to work on live notifications locally
                if (process.env.NODE_ENV !== 'production') {
                    return [2 /*return*/];
                }
                // Lazy load hub but give the page some time to settle before we
                // startup the WS connection
                return [4 /*yield*/, delay(3000)];
            case 3:
                // Lazy load hub but give the page some time to settle before we
                // startup the WS connection
                _b.sent();
                _b.label = 4;
            case 4:
                _b.trys.push([4, 6, , 7]);
                return [4 /*yield*/, import('../../utils/hub')];
            case 5:
                hubUtils = _b.sent();
                return [3 /*break*/, 7];
            case 6:
                e_1 = _b.sent();
                return [3 /*break*/, 7];
            case 7:
                if (!hubUtils) {
                    return [2 /*return*/];
                }
                hubChannel = eventChannel(function (emitter) {
                    hubUtils.setupHub(hub, function (message) { return emitter(message); });
                    return function () {
                        hubUtils.breakdownHub();
                    };
                }, 
                // going absolutely safe here, never drop a message
                buffers.expanding());
                _b.label = 8;
            case 8:
                if (!true) return [3 /*break*/, 11];
                return [4 /*yield*/, take(hubChannel)];
            case 9:
                message = _b.sent();
                _a = message.channel, channel = _a === void 0 ? '' : _a, data = message.data;
                channelName = channel.split('#')[0];
                return [4 /*yield*/, put(receiveHubMessage(channelName, data))];
            case 10:
                _b.sent();
                return [3 /*break*/, 8];
            case 11: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(receiveHubMessage, handleHubMessage),
                    fork(handleAppMounted), // we fork to avoid multiple executions
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map